import { useEffect, useState } from 'react';

export const useElementCreated = (elementSelector: string) => {
  const [isElementCreated, setIsElementCreated] = useState<boolean>(false);
  const [createdElement, setCreatedElement] = useState<Element | null>(null);
  let observer: MutationObserver;

  const checkElementCreated = () => {
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            if (node.matches(elementSelector) || node.querySelector(elementSelector)) {
              setIsElementCreated(true);
              setCreatedElement(document.querySelector(elementSelector));
              observer.disconnect();
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };
  useEffect(() => {
    checkElementCreated();
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return {
    isElementCreated,
    createdElement,
  };
};
